<template>
  <div>
    <!-- 面包屑组件 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/welcome' }">主页</el-breadcrumb-item>
      <el-breadcrumb-item>在读学生</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 内容卡片 -->
    <el-card>
      <!-- 查询框 -->
      <el-row :gutter="24">
        <el-col :span="3">
          <el-input
            v-model="queryInfo.realnameOrPhone"
            @clear="loadData"
            placeholder="手机号、姓名"
            clearable
          >
          </el-input>
        </el-col>
        <el-col :span="3">
          <el-select v-model="queryInfo.isSchedule" placeholder="学员排课" clearable>
            <el-option
              v-for="item in scheduleStatus"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="queryInfo.grade" placeholder="年级" clearable>
            <el-option
              v-for="item in gradeList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-select v-model="queryInfo.subject" placeholder="科目" clearable>
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-button @click="handleSearch" type="primary">搜索</el-button>
          <el-button @click="handleAdd" type="success">新增</el-button>
          <el-button @click="handleImportByVipss" type="info" plain>导入双师学生</el-button>
          <!-- 导出按钮：点击打开弹窗 -->
          <el-button @click="openExportDialog" type="warning" icon="el-icon-download">
            导出双师学生报表
          </el-button>
        </el-col>
      </el-row>

      <!-- 表格：已添加 loading 效果 -->
      <el-table :data="dataList" stripe :loading="loading">
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column label="学生" width="170">
          <template slot-scope="scope">
            <span>{{scope.row.realname}}({{scope.row.phone}})</span>
          </template>
        </el-table-column>
        <el-table-column label="年级"  prop="grade_dictText" width="110"></el-table-column>
        <el-table-column label="科目"  prop="subject" width="100"></el-table-column>
        <el-table-column label="学管师"  prop="followUpPersonId_dictText" width="110"></el-table-column>
        <el-table-column label="排课数量"  prop="joinFlag" width="90"></el-table-column>
        <el-table-column label="班课剩余" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.totalClassTimes}}次/{{scope.row.totalClassHours}}小时</span>
          </template>
        </el-table-column>
        <el-table-column label="一对一剩余" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.totalOneTimes}}次/{{scope.row.totalOneHours}}小时</span>
          </template>
        </el-table-column>

        <!-- 操作列按钮：已优化颜色 -->
        <el-table-column label="操作" width="320">
          <template slot-scope="scope">
            <el-button @click="selectSuit(scope.row)" type="text" style="color:#3e82f5">选套餐</el-button>
            <el-button @click="selectClass(scope.row)" type="text" style="color:#17c2bd">选班</el-button>
            <el-button @click="handleDelete(scope.row)" type="text" style="color:#f53f3f">删除</el-button>
            <el-button @click="handleEdit(scope.row)" type="text" style="color:#ff9f00">编辑</el-button>
            <el-button @click="handleDetail(scope.row)" type="text" style="color:#6f7cb2">详情</el-button>
            <el-button
              @click="goVipssStudentDetail(scope.row)"
              type="text"
              style="color:#009966">
              学习记录
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 页数码 -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="queryInfo.pageNo"
        :page-size="queryInfo.pageSize"
        :total="total"
        background
      ></el-pagination>
    </el-card>

    <!-- ====================== 导出时间选择弹窗 ====================== -->
    <el-dialog
      title="导出双师学生报表"
      :visible.sync="exportDialogVisible"
      width="500px"
      @close="resetExportTime"
    >
      <el-form :model="exportTimeForm" label-width="120px">
        <el-form-item label="训练时间范围">
          <el-date-picker
            v-model="exportTimeForm.trainTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleExportReport">确认导出</el-button>
      </div>
    </el-dialog>

    <!-- 选择套餐 -->
    <el-dialog title="选择套餐" :visible.sync="dialogVisibleSelectSuit" :close-on-click-modal="false" width="1100px">
      <el-form :model="setMealPageParamVO">
        <el-row :gutter="24">
          <el-col :span="18">
            <span></span>
          </el-col>
        </el-row>
      </el-form>
      <el-form :model="setMealPageParamVO">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="">
              <el-input placeholder="搜索套餐" v-model="setMealPageParamVO.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="">
              <el-button @click="getSetMealList" type="primary">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="suitList" @selection-change="handleSelectionSuit" stripe>
        <el-table-column type="selection" width="55" :selectable="isSelectable"></el-table-column>
        <el-table-column property="name" label="套餐名称" width="400">
          <template slot-scope="scope">
            <span v-if="scope.row.openStatus==0" style="color: gray;text-decoration: line-through;" title="未开启">{{scope.row.name}}2</span>
            <span v-if="scope.row.openStatus==1">{{scope.row.name}}1</span>
          </template>
        </el-table-column>
        <el-table-column property="type" label="套餐类型" width="150">
          <template slot-scope="scope">
            {{scope.row.type==1?'限次':scope.row.type==4?'限时':''}}
          </template>
        </el-table-column>
        <el-table-column property="times" label="次数(含赠送)" width="150">
          <template slot-scope="scope">
            {{scope.row.times != null?(scope.row.times + scope.row.giveTimes) :'—'}}
          </template>
        </el-table-column>
        <el-table-column property="hours" label="小时数(含赠送)" width="150">
          <template slot-scope="scope">
            {{scope.row.hours != null?(scope.row.hours + scope.row.giveHours) :'—'}}
          </template>
        </el-table-column>
        <el-table-column property="price" label="价格" width="150">
          <template slot-scope="scope">
            ￥{{scope.row.price}}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" @current-change="handleCurrentChangeSuit" :total="setMealPageParamVOTotal"
                     @size-change="handleSizeChangeSuit" :current-page.sync="setMealPageParamVO.pageNo"
                     layout="prev, pager, next" :page-size="setMealPageParamVO.pageSize">
      </el-pagination>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSelectSuit = false">取 消</el-button>
        <el-button type="primary" @click="commitSelectSuit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择班级" :visible.sync="dialogVisibleSelectClass" :close-on-click-modal="false" width="1100px">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="班课班级" name="first">
          <el-form :model="classClassPageParamVO">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="">
                  <el-input placeholder="请输入班级名称" v-model="classClassPageParamVO.name" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="">
                  <el-input placeholder="请输入课程名称" v-model="classClassPageParamVO.courseName" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="">
                  <el-button @click="getClassData" type="primary">搜索</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table :data="classList" @selection-change="handleSelectionClass" stripe>
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column property="className" label="班级名称" width="130"></el-table-column>
            <el-table-column property="startDates" label="开班时间"></el-table-column>
            <el-table-column property="teacherName" label="上课老师"></el-table-column>
            <el-table-column property="classRoom" label="上课教室"></el-table-column>
            <el-table-column property="status" label="班级状态">
              <template slot-scope="scope">
                {{scope.row.status==0?'未开始':scope.row.status==1?'进行中':''}}
              </template>
            </el-table-column>
            <el-table-column property="studentNum" label="学员人数"></el-table-column>
            <el-table-column property="maxNum" label="容纳人数"></el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <el-button v-if="scope.row.joinFlag == 1" @click="handleClass(scope.row,'offDuty')" type="text" style="color:#f53f3f">退班</el-button>
                <el-button v-if="scope.row.joinFlag == 0"  @click="handleClass(scope.row,'inClass')" type="text" style="color:#3e82f5">入班</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination" @current-change="handleCurrentChangeClass" :total="setClassPageParamVOTotal"
                         @size-change="handleSizeChangeClass" :current-page.sync="classClassPageParamVO.pageNo"
                         layout="prev, pager, next" :page-size="classClassPageParamVO.pageSize">
          </el-pagination>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleSelectClass = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisibleSelectClass = false">确 定</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="1对1班级" name="second">
          <el-form :model="setMealPageParamVO">
            <el-row :gutter="24">
              <el-col :span="5">
                <el-form-item label="">
                  <el-button @click="handleAddOnebyone" type="success">新增1对1班级</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-table :data="oneByOneList">
            <el-table-column property="className" label="班级名称"></el-table-column>
            <el-table-column property="courseName" label="课程名称"></el-table-column>
            <el-table-column property="teacherName" label="上课老师"></el-table-column>
            <el-table-column property="startDates" label="创建时间"></el-table-column>
            <el-table-column property="studentNum" label="学员人数"></el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <el-button v-if="scope.row.joinFlag == 1" @click="handleOneByOneClass(scope.row,'offDuty')" type="text" style="color:#f53f3f">退班</el-button>
                <el-button v-if="scope.row.joinFlag == 0"  @click="handleOneByOneClass(scope.row,'inClass')" type="text" style="color:#3e82f5">入班</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination" @current-change="handleCurrentChangeClass" :total="setOneClassPageParamVOTotal"
                         @size-change="handleSizeChangeClass" :current-page.sync="classOneOnOnePageParamVO.pageNo"
                         layout="prev, pager, next" :page-size="classOneOnOnePageParamVO.pageSize">
          </el-pagination>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleSelectClass = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisibleSelectClass = false">确 定</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 入班二次确认弹窗 -->
    <el-dialog title="确定入班" :visible.sync="dialogFormVisibleinClass" :close-on-click-modal="false">
      <el-form :model="studentRelateClassModel">
        <el-form-item label="选择具体上课时间" label-width="150px">
          <el-select v-model="studentRelateClassModel.classScheduleId" placeholder="选择具体上课时间">
            <el-option :label="item.label" :value="item.value" v-for="(item,index) in timeList" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleinClass = false">取 消</el-button>
        <el-button type="primary" @click="addStudentTimeClass">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增一对一班级确认弹窗 -->
    <el-dialog title="新增1对1班级" :visible.sync="dialogFormVisibleinOneByOne" :close-on-click-modal="false">
      <el-form :model="setMealPageParamVO">
        <el-form-item label="选择学员" label-width="150px">
          <el-select v-model="setMealPageParamVO.name" placeholder="选择具体上课时间">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleinOneByOne = false">取 消</el-button>
        <el-button type="primary" @click="confirmOneByOne">确定并排课</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { formatDate } from "../../../plugins/date.js";
  export default {
    data() {
      return {
        loading: false,
        // 导出弹窗 + 时间参数
        exportDialogVisible: false,
        exportTimeForm: {
          trainTimeRange: [] // 时间范围数组 [开始时间, 结束时间]
        },

        //用于获取数据列表
        queryInfo: {
          realnameOrPhone:'',
          isSchedule: null,
          grade: null,
          subject: '',
          pageSize: 10,
          pageNo: 1,
        },
        // 选择班级切换参数
        activeName:'first',
        // 选择套餐弹窗
        dialogVisibleSelectSuit:false,
        // 选择班级弹窗
        dialogVisibleSelectClass:false,
        // 确定入班
        dialogFormVisibleinClass:false,
        // 新增一对一班级弹窗
        dialogFormVisibleinOneByOne:false,
        // 排课状态
        scheduleStatus:[
          { value:0, label:'全部' },
          { value:1, label:'未排课' },
          { value:2, label:'已排课' }
        ],
        // 选择套餐搜索
        setMealPageParamVO:{
          name:'',
          isSchedule:null,
          pageNo:1,
          pageSize:10,
          realnameOrPhone:''
        },
        setMealPageParamVOTotal:0,
        // 套餐列表
        suitList:[],
        selectClassStudentId:'',
        selectSuitStudentId:'',
        selectList:[],
        selectSuitList:[],
        dataList: [],
        total: 0,
        // 选择班级参数
        classClassPageParamVO:{
          selectClassStudentId: '',
          name:'',
          courseName:'',
          pageNo:1,
          pageSize:10,
          sort:null,
          status:null,
          teacherId:'',
        },
        setOneClassPageParamVOTotal:0,
        setClassPageParamVOTotal:0,
        classList:[],
        selectClassList:[],
        timeList:[],
        studentRelateClassModel:{
          classScheduleId:''
        },
        gradeList: [
          {id: 2,name: '二年级'},
          {id: 3,name: '三年级'},
          {id: 4,name: '四年级'},
          {id: 5,name: '五年级'},
          {id: 6,name: '六年级'},
          {id: 7,name: '七年级'},
          {id: 8,name: '八年级'},
          {id: 9,name: '九年级'},
          {id: 10,name: '高一'},
          {id: 11,name: '高二'},
          {id: 12,name: '高三'}
        ],
        subjectList: [
          {id: 1,name: '数学'},
          {id: 2,name: '语文'},
          {id: 3,name: '英语'},
          {id: 4,name: '科学'},
          {id: 5,name: '物理'},
          {id: 6,name: '化学'},
          {id: 7,name: '生物'}
        ],
        classInClassIds:'',
        oneByOneList:[],
        classOneOnOnePageParamVO:{
          selectClassStudentId: '',
          name:'',
          pageNo:1,
          pageSize:10,
          sort:null,
          status:null,
          teacherId:''
        }
      };
    },
    created() {
      this.loadData();
    },
    filters: {
      formatDate(time) {
        var date = new Date(time);
        return formatDate(date, "yyyy-MM-dd");
      },
    },
    methods: {
      // ====================== 导出相关方法 ======================
      // 打开导出弹窗
      openExportDialog() {
        this.exportDialogVisible = true;
      },
      // 关闭时重置时间
      resetExportTime() {
        this.exportTimeForm.trainTimeRange = [];
      },

      // 数据加载（已优化 loading）
      async loadData() {
        this.loading = true;
        try {
          const { data: res } = await this.$http.post("/ea/student/student/list",this.queryInfo);
          if (res.code !== 200) {
            this.$message.error(res.message);
            return;
          }
          this.dataList = res.result.records;
          this.total = res.result.total;
        } finally {
          this.loading = false;
        }
      },
      // 勾选学员
      handleSelectionChange(val) {
        this.selectList = val;
      },
      // 勾选套餐
      handleSelectionSuit(val){
        this.selectSuitList = val;
      },
      // 勾选班级
      handleSelectionClass(val){
        this.selectClassList = val;
      },
      goVipssStudentDetail(row) {
        this.$router.push({
          path: '/vipssStudentCapterStatistics',
          query: {
            phone: row.phone,
            realname: row.realname,
            grade: row.grade
          }
        })
      },
      goVipssStudentDetail1(row) {
        this.$router.push({
          path: '/vipssStudentDetail',
          query: {
            phone: row.phone,
            realname: row.realname,
            grade: row.grade
          }
        })
      },
      // 详情
      handleDetail(row){
        this.$router.push({
          path:'studentDetail',
          query: { id:row.id }
        })
      },
      // 删除
      handleDelete(row){
        this.$confirm('此操作将永久删除该学生, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteStudent(row.id);
        }).catch(() => {
          this.$message({ type: 'info', message: '已取消删除' });
        });
      },
      async deleteStudent(id) {
        let data = { id:id };
        const { data: res } = await this.$http.post("/ea/student/student/delete",data);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("删除成功!");
        this.loadData();
      },
      // 新增
      handleAdd(){
        this.$router.push('/createStudent');
      },
      handleImportByVipss(){
        this.$router.push('/importVipssStudent');
      },

      // ====================== 导出报表（携带时间参数） ======================
      handleExportReport() {
        const [trainStartTime, trainEndTime] = this.exportTimeForm.trainTimeRange || [];

        // 组装参数：页面查询条件 + 训练时间
        const params = {
          ...this.queryInfo,
          beginTimeStr: trainStartTime || '',
          endTimeStr: trainEndTime || ''
        };

        let url = '/ea/student/student/exportReportXls';
        this.fetchDownloadProgress(url, params, '双师学生报表');

        // 导出后关闭弹窗
        this.exportDialogVisible = false;
      },

      fetchDownloadProgress(url,searchData,fileName) {
        this.$http({
          method: "post",
          url: url,
          responseType: "blob",
          data: searchData
        })
          .then(res => {
            var blob = new Blob([res.data], {type: 'application/vnd.ms-excel;charset=utf-8'})
            var downloadElement = document.createElement('a');
            var href = window.URL.createObjectURL(blob);
            downloadElement.href = href;
            downloadElement.download = '双师学生报表.xls';
            document.body.appendChild(downloadElement);
            downloadElement.click();
            document.body.removeChild(downloadElement);
            window.URL.revokeObjectURL(href);
          })
          .catch(err => {
            console.log(err.message);
          });
      },

      handleEdit(record) {
        this.$router.push({
          name: "createStudent",
          params: {recordDate:record,type:'edit'}
        });
      },
      // 搜索
      handleSearch(){
        this.loadData();
      },
      // 选择套餐
      selectSuit(row){
        this.selectSuitStudentId = row.id;
        this.setMealPageParamVO.pageNo = 1;
        this.setMealPageParamVO.name = '';
        this.getSetMealList();
        this.dialogVisibleSelectSuit = true;
      },
      // 提交选择套餐
      commitSelectSuit(){
        let list = [];
        this.selectSuitList.map(e=>{ list.push(e.id); })
        let str = list.join(',');
        let studentRelateIdModel = {
          id:str,
          studentId:this.selectSuitStudentId
        };
        this.setSetMeal(studentRelateIdModel);
      },
      // 选套餐
      async setSetMeal(studentRelateIdModel) {
        const { data: res } = await this.$http.post(`/ea/student/student/setSetMeal`,studentRelateIdModel);
        if (res.code !== 200) return this.$message.error(res.message);
        this.dialogVisibleSelectSuit = false;
        this.$message.success(res.message);
        this.loadData();
      },
      // 获取所有套餐信息
      async getSetMealList() {
        const { data: res } = await this.$http.post(`/ea/student/setMeal/list`,this.setMealPageParamVO);
        if (res.code !== 200) return this.$message.error(res.message);
        this.suitList = res.result.records;
        this.setMealPageParamVOTotal = res.result.total;
      },
      // 套装页码切换
      handleCurrentChangeSuit(pageNum){
        this.setMealPageParamVO.pageNo = pageNum;
        this.getSetMealList();
      },
      handleSizeChangeSuit(pageSize){
        this.setMealPageParamVO.pageSize = pageSize;
        this.getSetMealList();
      },
      // 获取班级列表
      async getClassData(){
        const { data: res } = await this.$http.post(`/ea/student/classClass/list`,this.classClassPageParamVO);
        if (res.code !== 200) return this.$message.error(res.message);
        this.classList = res.result.records;
        this.setClassPageParamVOTotal = res.result.total;
      },
      // 获取一对一班级列表
      async getOneClassData(){
        const { data: res } = await this.$http.post(`/ea/student/classOneOnOne/list`,this.classOneOnOnePageParamVO);
        if (res.code !== 200) return this.$message.error(res.message);
        this.oneByOneList = res.result.records;
        this.setOneClassPageParamVOTotal = res.result.total;
      },
      // 一对一班级页码切换
      handleCurrentChangeOneClass(pageNum){
        this.classOneOnOnePageParamVO.pageNo = pageNum;
        this.getOneClassData();
      },
      handleSizeChangeOneClass(pageSize){
        this.classOneOnOnePageParamVO.pageSize = pageSize;
        this.getOneClassData();
      },
      // 班级页码切换
      handleCurrentChangeClass(pageNum){
        this.classClassPageParamVO.pageNo = pageNum;
        this.getClassData();
      },
      handleSizeChangeClass(pageSize){
        this.classClassPageParamVO.pageSize = pageSize;
        this.getClassData();
      },
      // 选择班级
      selectClass(row){
        this.getClassData();
        this.getOneClassData();
        this.selectClassStudentId = row.id;
        this.classClassPageParamVO.selectClassStudentId =  row.id;
        this.classOneOnOnePageParamVO.selectClassStudentId =  row.id;
        this.classClassPageParamVO.name = '';
        this.classClassPageParamVO.courseName = '';
        this.dialogVisibleSelectClass = true;
      },

      handleCurrentChange(page) {
        this.queryInfo.pageNo = page;
        this.loadData();
      },
      // 选择班级tab切换
      handleClick(tab, event) {
        this.loadData();
      },
      // 选择班级/班课班级/退班/入班
      handleClass(row,type){
        if(type=='offDuty'){
          this.$confirm('此操作将退出该班级, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.removeStudentClass(row);
          }).catch(() => {
            this.$message.info('已取消退出');
          });
        }else{
          this.$confirm('此操作将进入该班级, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.classInClassIds = row.id;
            this.studentRelateClassModel.classScheduleId = '';
            this.addStudentTimeClass();
            this.queryScheduleById(row);
          }).catch(() => {
            this.$message.info('已取消入班');
          });
        }
      },
      // 退班
      async removeStudentClass(row){
        let studentRelateClassModel = {
          classIds:row.id,
          studentId:this.selectClassStudentId,
          classScheduleId:''
        };
        const { data: res } = await this.$http.post(`/ea/student/student/removeStudentClass`,studentRelateClassModel);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("退出成功!");
        this.getClassData();
        this.loadData();
      },
      // 一对一退班
      async removeOneStudentClass(row){
        let classRelateStudentModel = {
          classId:row.id,
          studentIds:this.selectClassStudentId,
          classScheduleId:''
        };
        const { data: res } = await this.$http.post(`/ea/student/classOneOnOne/removeStudent`,classRelateStudentModel);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("退出成功!");
        this.getOneClassData();
        this.loadData();
      },
      // 班级排课查询
      async queryScheduleById(row){
        this.timeList = [];
        let id = row.id;
        let idModel = { id:id };
        const { data: res } = await this.$http.post(`/ea/student/classClass/queryScheduleById`,idModel);
        if (res.code !== 200) return this.$message.error(res.message);
        let list  = res.result;
        list.map(e=>{
          let item = {
            label:e.startDates+'/'+e.beginTime+'-'+e.startDates+'/'+e.endTime,
            value:e.id
          };
          this.timeList.push(item);
        })
      },
      // 选择具体上课时间后入班
      addStudentTimeClass(){
        this.addStudentClass();
        this.dialogFormVisibleinClass = false;
      },
      // 入班
      async addStudentClass(){
        let studentRelateClassModel = {
          classIds:this.classInClassIds,
          studentId:this.selectClassStudentId,
          classScheduleId:this.studentRelateClassModel.classScheduleId
        };
        const { data: res } = await this.$http.post(`/ea/student/student/addStudentClass`,studentRelateClassModel);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("入班成功!");
        this.getClassData();
        this.getOneClassData();
        this.loadData();
      },

      // 新增一对一班级
      handleAddOnebyone(){
        this.$router.push("/createOneByOne");
      },
      // 一对一班级操作
      handleOneByOneClass(row,type){
        if(type=='offDuty'){
          this.$confirm('此操作将退出该班级, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.classInClassIds = row.id;
            this.removeOneStudentClass(row);
          }).catch(() => {
            this.$message.info('已取消退班');
          });
        }else{
          this.$confirm('此操作将加入该班级, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.classInClassIds = row.id;
            this.addStudentClass()
          }).catch(() => {
            this.$message.info('已取消入班');
          });
        }
      },
      // 一对一班级删除
      async deleteOneClass(id) {
        let idModel = { id:id };
        const { data: res } = await this.$http.post("/ea/student/classOneOnOne/delete",idModel);
        if (res.code !== 200) return this.$message.error(res.message);
        this.$message.success("删除成功!");
        this.getOneClassData();
      },
      // 新增一对一班级并排课
      confirmOneByOne(){
        this.dialogFormVisibleinOneByOne = false;
        this.$router.push('/teachingSchedule');
      },
      isSelectable(row) {
        return row.openStatus == 1;
      },
    },
  };
</script>

<style scoped>
  .el-card {
    min-height: 500px;
  }
  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
</style>
